var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-file-input',{attrs:{"chips":"","multiple":""},on:{"change":_vm.agregar}}),_vm._v(" value: "+_vm._s(_vm.value)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }